// Etiquetas legibles de departamento (product_type) y categoría de producto.
// Mismo criterio que el listado de Productos y la Toma de Órdenes.

export const DEPARTAMENTO_LABELS = {
  BETEL: 'Betel Natural',
  NATURALANDLAB: 'NaturalAndLab',
  OTHER_BRANDS: 'Otras Marcas',
  OTRAS_MARCAS: 'Otras Marcas',
  INGREDIENT: 'Ingredientes',
  PACKAGING_MATERIAL: 'Material de Empaque',
  FINISHED_PRODUCT: 'Producto Terminado',
  RAW_MATERIAL: 'Materia Prima'
};

export const CATEGORIA_LABELS = {
  CAPSULES: 'Cápsulas', POWDERS: 'Polvos', OILS: 'Aceites', TEAS: 'Infusiones',
  CREAMS: 'Cremas', LEAVES: 'Hojas', LIQUIDS: 'Líquidos', SUPPLEMENTS: 'Suplementos',
  TINCTURES: 'Tinturas', TABLETS: 'Tabletas', EXTRACTS: 'Extractos', HERBS: 'Hierbas',
  VITAMINS: 'Vitaminas', MINERALS: 'Minerales', SUPPLIES: 'Insumos',
  PACKAGING: 'Empaque', OTHER: 'Otros'
};

export const labelDepartamento = (v) =>
  DEPARTAMENTO_LABELS[String(v || '').toUpperCase()] || v || '';

export const labelCategoria = (v) =>
  CATEGORIA_LABELS[String(v || '').toUpperCase()] || v || '';
